/* eslint-disable import/default -- Rule isn't able to locate CJS style exports */import emceeDevelopmentConfig from '../application-config/emcee.development';
import emceeLocalConfig from '../application-config/emcee.local';
import emceeProductionConfig from '../application-config/emcee.production';
import emceeStagingConfig from '../application-config/emcee.staging';
export function emptyFunction() {
  /* do nothing */
}
export function preventDefault(e) {
  e.preventDefault();
}
export function resolveFieldWithFallback(resolve, maybePrimary, fallback) {
  return resolve(maybePrimary || fallback);
}
export const getApplicationConfigForEnv = environment => {
  switch (environment) {
    case 'local':
      return emceeLocalConfig;
    case 'dev':
      return emceeDevelopmentConfig;
    case 'staging':
      return emceeStagingConfig;
    case 'prod':
      return emceeProductionConfig;
    default:
      throw new Error('Invalid environment provided: ' + environment);
  }
};